const SelectTicketsPlaceholder = () => {
  return (
    <div className="container mx-auto px-4 pb-8">
      <div className="flex gap-8 flex-col md:flex-row">
        <div className="flex-1 space-y-4">
          {[1, 2].map((index) => (
            <div
              key={index}
              className="min-h-[180px] rounded-lg animate-pulse bg-gray-300"
            />
          ))}
        </div>

        <div className="hidden md:block w-80">
          <div className="border border-theme_text_light rounded-lg p-6 sticky top-8 space-y-4">
            <div className="h-6 w-32 bg-gray-300 animate-pulse rounded" />

            {[1, 2].map((index) => (
              <div key={index} className="flex justify-between">
                <div className="h-4 w-24 bg-gray-300 animate-pulse rounded" />
                <div className="h-4 w-16 bg-gray-300 animate-pulse rounded" />
              </div>
            ))}

            <div className="mt-4 pt-4 border-t border-theme_text_light space-y-4">
              <div className="flex justify-between">
                <div className="h-6 w-20 bg-gray-300 animate-pulse rounded" />
                <div className="h-6 w-24 bg-gray-300 animate-pulse rounded" />
              </div>
              <div className="h-10 w-full bg-gray-300 animate-pulse rounded" />
            </div>
          </div>
        </div>

        <div className="md:hidden fixed bottom-0 left-0 right-0 bg-theme_background border-t border-theme_text_light p-4">
          <div className="container mx-auto">
            <div className="flex justify-between items-center mb-4">
              <div className="h-5 w-20 bg-gray-300 animate-pulse rounded" />
              <div className="h-5 w-24 bg-gray-300 animate-pulse rounded" />
            </div>
            <div className="h-10 w-full bg-gray-300 animate-pulse rounded" />
          </div>
        </div>
      </div>
    </div>
  )
}

export { SelectTicketsPlaceholder }
